export default __webpack_public_path__ + "assets/webgl/picking-9.41508224.glb";